module.exports = __webpack_public_path__ + "static/media/profile_shop.c25be53d.svg";